import { useEffect, useState } from 'react';
import { EE } from '@services/ServiceSpinner/EE';

export const useSpinnerVisible = (): boolean => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    let cleanUp = false;
    const disposers = [EE.on('spinner_show', () => !cleanUp && setVisible(true)), EE.on('spinner_hide', () => !cleanUp && setVisible(false))];
    return () => {
      cleanUp = true;
      disposers.forEach(i => i());
    };
  }, []);

  return visible;
};
